var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Unofficial_JavaScript_logo_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7df1e;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6896",
    "data-name": "Rectangle 6896",
    className: "cls-1",
    width: 111,
    height: 111,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13506",
    "data-name": "Path 13506",
    d: "M217.344,327.15c2.538,4.144,5.84,7.19,11.68,7.19,4.906,0,8.04-2.452,8.04-5.84,0-4.06-3.22-5.5-8.62-7.86l-2.96-1.27c-8.544-3.64-14.22-8.2-14.22-17.84,0-8.88,6.766-15.64,17.34-15.64,7.528,0,12.94,2.62,16.84,9.48l-9.22,5.92c-2.03-3.64-4.22-5.074-7.62-5.074-3.468,0-5.666,2.2-5.666,5.074,0,3.552,2.2,4.99,7.28,7.19l2.96,1.268c10.06,4.314,15.74,8.712,15.74,18.6,0,10.66-8.374,16.5-19.62,16.5-11,0-18.1-5.24-21.576-12.108Zm-41.826,1.026c1.86,3.3,3.552,6.09,7.62,6.09,3.89,0,6.344-1.522,6.344-7.44v-40.26h11.84v40.42c0,12.26-7.188,17.84-17.68,17.84-9.48,0-14.97-4.906-17.762-10.815Z",
    transform: "translate(-147.704 -243.712)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.534b457eece3194c15c97773114c819f.svg";
export { ForwardRef as ReactComponent };